import { render, staticRenderFns } from "./productionOutput.vue?vue&type=template&id=bf98e124&scoped=true"
import script from "./productionOutput.vue?vue&type=script&lang=js"
export * from "./productionOutput.vue?vue&type=script&lang=js"
import style0 from "./productionOutput.vue?vue&type=style&index=0&id=bf98e124&prod&lang=scss&scoped=true"
import style1 from "./productionOutput.vue?vue&type=style&index=1&id=bf98e124&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf98e124",
  null
  
)

export default component.exports